
export interface PermissionGroup {
  id: string;
  label: string;
  permissions: Permission[];
}

export interface Permission {
  id: string;
  label: string;
  children?: Permission[];
}

export const PERMISSION_GROUPS: PermissionGroup[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    permissions: [
      { id: 'dashboard.view', label: 'Dashboard' },
    ],
  },
  {
    id: 'control',
    label: 'Control Panel',
    permissions: [
      { id: 'control.users.manage', label: 'Users Manage' },
      { id: 'control.roles.manage', label: 'Roles' },
    ],
  },
  {
    id: 'doctors',
    label: 'Doctors',
    permissions: [
      { id: 'doctors.manage', label: 'Doctors Manages' },
      { id: 'doctors.view', label: 'Report Doctors' },
    ],
  },
  {
    id: 'patients',
    label: 'Patient Info',
    permissions: [
      { id: 'patients.view', label: 'Patient' },
      { id: 'patients.create', label: 'Patient Report Check' },
      { id: 'patients.edit', label: 'Bulk SMS Send' },
      { id: 'patients.delete', label: 'SMS Others Number' },
      { id: 'patients.bulk_sms_history', label: 'Bulk SMS History' },
      { id: 'patients.cases', label: 'Cases' },
      { id: 'patients.case_handlers', label: 'Case Handlers' },
      { id: 'patients.admissions', label: 'Patient Admissions' },
      { id: 'patients.smart_card', label: 'Patient Smart Card' },
    ],
  },
  {
    id: 'bed_management',
    label: 'Bed Management',
    permissions: [
      { id: 'bed_management.view', label: 'Bed Types' },
      { id: 'bed_management.manage', label: 'Beds' },
      { id: 'bed_management.assigns', label: 'Bed Assigns' },
      { id: 'bed_management.status', label: 'Bed Status' },
    ],
  },
  {
    id: 'ipd',
    label: 'IPD',
    permissions: [
      { id: 'ipd.admission', label: 'Admission' },
      { id: 'ipd.diagnosis', label: 'Diagnosis Name' },
      { id: 'ipd.invoice', label: 'IPD Invoice' },
      { id: 'ipd.bill_summary', label: 'Bill Summary' },
      { id: 'ipd.receive_payment', label: 'Receive Payment' },
      { id: 'ipd.refund', label: 'Refund from Advance' },
      { id: 'ipd.release_patient', label: 'Release Patient' },
    ],
  },
  {
    id: 'appointment',
    label: 'Appointment Info',
    permissions: [
      { id: 'appointment.view', label: 'Appointment' },
      { id: 'appointment.create', label: 'Appointment Report' },
    ],
  },
  {
    id: 'billings',
    label: 'Billings',
    permissions: [
      { id: 'billings.account', label: 'Account' },
      { id: 'billings.transaction_head', label: 'Transaction Head' },
      { id: 'billings.bulk_price_set', label: 'Bulk Price set' },
      { id: 'billings.invoices', label: 'Invoices' },
      { id: 'billings.due_collection', label: 'Due Collection' },
      { id: 'billings.due_report', label: 'Due Report' },
      { id: 'billings.invoice_report', label: 'Invoice Report' },
      { id: 'billings.cash_collection_report', label: 'Cash Collection Report' },
      { id: 'billings.doctor_wise_report', label: 'Doctor Wise Report' },
      { id: 'billings.counter_wise_report', label: 'Counter Wise Report' },
      { id: 'billings.test_report', label: 'Test Report' },
      { id: 'billings.pc_payment', label: 'PC Payment' },
      { id: 'billings.summary_report', label: 'Summary Report' },
      { id: 'billings.expense_summary', label: 'Expense Summary' },
      { id: 'billings.voucher_head', label: 'Voucher Head' },
      { id: 'billings.debit_voucher', label: 'Debit Voucher' },
      { id: 'billings.debit_voucher_check', label: 'Debit Voucher Check' },
      { id: 'billings.credit_voucher', label: 'Credit Voucher' },
      { id: 'billings.payment', label: 'Payment' },
      { id: 'billings.payment_report', label: 'Payment Report' },
      { id: 'billings.general_ledger', label: 'General Ledger' },
      { id: 'billings.daily_cashbook', label: 'Daily Cashbook' },
      { id: 'billings.commission_report', label: 'Commission Report' },
      { id: 'billings.balance_transfer', label: 'Balance Transfer' },
      { id: 'billings.fund_manages', label: 'Fund Manages' },
    ],
  },
  {
    id: 'prescription',
    label: 'Prescription',
    permissions: [
      { id: 'prescription.view', label: 'Prescription' },
      { id: 'prescription.create', label: 'Create Prescription' },
    ],
  },
  {
    id: 'medicine',
    label: 'Medicine Info',
    permissions: [
      { id: 'medicine.medicines', label: 'Medicines' },
      { id: 'medicine.medicine_group', label: 'Medicine Group' },
      { id: 'medicine.medicine_brand', label: 'Medicine Brand' },
    ],
  },
  {
    id: 'diagnosis',
    label: 'Diagnosis Info',
    permissions: [
      { id: 'diagnosis.categories', label: 'Diagnosis Categories' },
      { id: 'diagnosis.test_name', label: 'Test Name' },
      { id: 'diagnosis.pathology_setup', label: 'Pathology Setup' },
      { id: 'diagnosis.pathology_lab_report', label: 'Pathology Lab Report' },
      { id: 'diagnosis.molecular_pathology_setup', label: 'Molecular Pathology Setup' },
      { id: 'diagnosis.molecular_pathology_report', label: 'Molecular Pathology Report' },
      { id: 'diagnosis.usg_setup', label: 'USG Setup' },
      { id: 'diagnosis.usg_report', label: 'USG Report' },
      { id: 'diagnosis.xray_report', label: 'X-Ray Report' },
    ],
  },
  {
    id: 'services',
    label: 'Services Info',
    permissions: [
      { id: 'services.insurances', label: 'Insurances' },
      { id: 'services.packages', label: 'Packages' },
      { id: 'services.services', label: 'Services' },
      { id: 'services.ambulances', label: 'Ambulances' },
      { id: 'services.pharmacy', label: 'Pharmacy' },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    permissions: [
      { id: 'settings.setting', label: 'Setting' },
      { id: 'settings.invoice_type', label: 'Invoice Type' },
      { id: 'settings.logo', label: 'Logo' },
    ],
  },
];

export function getAllPermissionIds(): string[] {
  const ids: string[] = [];
  
  PERMISSION_GROUPS.forEach(group => {
    group.permissions.forEach(permission => {
      ids.push(permission.id);
      if (permission.children) {
        permission.children.forEach(child => {
          ids.push(child.id);
        });
      }
    });
  });
  
  return ids;
}

export function isValidPermission(permissionId: string): boolean {
  return getAllPermissionIds().includes(permissionId);
}

export function getPermissionLabel(permissionId: string): string | null {
  for (const group of PERMISSION_GROUPS) {
    for (const permission of group.permissions) {
      if (permission.id === permissionId) {
        return permission.label;
      }
      if (permission.children) {
        for (const child of permission.children) {
          if (child.id === permissionId) {
            return child.label;
          }
        }
      }
    }
  }
  return null;
}
